import {
  Body1,
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
  Input,
  makeStyles,
  Textarea,
} from "@fluentui/react-components";
import {
  Attach20Regular,
  Dismiss16Regular,
  Dismiss24Regular,
  Send24Filled,
} from "@fluentui/react-icons";
import React, { useState } from "react";
import FormikInputRequest from "../../../../service/hook/useFormik";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import Dropzone from "react-dropzone";
import {
  fetchCustomerMessages,
  postMessage,
} from "../../../../redux/clientPortal/clientPortalslice";
const useStyles = makeStyles({
  dialogContent: {
    // border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "4px",
  },
  attachmentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  chip: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    fontSize: "14px",
    color: "#616161",
    gap: "5px",
  },
});
function ComposeMessage({ open, onClose, customerId, notify }: any) {
  const styles = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const [actionProcessing, setActionProcessing] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const removeFile = () => {
    setUploadedFiles([]);
    formikData.setFieldValue("file", "");
  };
  const formikData = FormikInputRequest({
    initialValues: {
      subject: "",
      message: "",
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.subject) {
        errors.subject = "Subject is required";
      } else if (values.subject.length < 5) {
        errors.subject = "Subject must be at least 5 characters long";
      } else if (values.subject.length > 150) {
        errors.subject = "Subject must not exceed 100 characters";
      }
      if (values.message.length > 5000) {
        errors.message = "Message must not exceed 500 characters";
      }
      return errors;
    },
    onSubmitFn: async (values: any) => {
      setActionProcessing(true);
      const { subject, message } = values;

      try {
        await dispatch(
          postMessage({
            customer_id: customerId,
            subject,
            message,
            sent_by_ifa: 1,
            isdocument_message: 0,
            file: uploadedFiles[0],
          })
        ).then((res) => {

          if (!res.payload.isError) {

            notify(res.payload.message, "", "success");
            setTimeout(() => {
              formikData.resetForm();

              if (customerId) {
                dispatch(fetchCustomerMessages({ customerId }));
              }
              onClose();
            }, 1000);
            setActionProcessing(false);
          }
        });
      } catch (error: any) {
        notify(error, "", "error");
        setActionProcessing(false);

        //   showSnackbar(error, "error");
      }
    },
  });
  return (
    <Dialog open={open} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  aria-label="close"
                  icon={
                    <Dismiss24Regular
                      onClick={() => {
                        formikData.resetForm();
                        removeFile();
                        onClose();
                      }}
                    />
                  }
                />
              </DialogTrigger>
            }
          >
            Compose Message
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Field
              validationState={
                formikData.touched.subject && formikData.errors.subject
                  ? "error"
                  : "none"
              }
              validationMessage={`${
                (formikData.touched.subject && formikData?.errors?.subject) ||
                ""
              }`}
            >
              <Input
                placeholder="Subject"
                onFocus={() => formikData.setFieldTouched("subject")}
                type="text"
                name="subject"
                value={formikData.values.subject}
                onChange={formikData.handleChange}
              />
            </Field>
            <Field
              validationState={
                formikData.touched.message && formikData.errors.message
                  ? "error"
                  : "none"
              }
              validationMessage={`${
                (formikData.touched.message && formikData?.errors?.message) ||
                ""
              }`}
            >
              <Textarea
                placeholder="Message"
                name="message"
                rows={5}
                value={formikData.values.message}
                onChange={formikData.handleChange}
              />
            </Field>
            <div className="justigy_between">
              {uploadedFiles.map((file: any, index: any) => (
                <div className="list-upload-item" key={index}>
                  {file.name} - {(file.size / 1024).toFixed(2)} KB
                  <Dismiss16Regular onClick={() => removeFile()} />
                </div>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 10,
                margin: "10px 0",
              }}
            >
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<Send24Filled />}
                onClick={() => formikData.handleSubmit()}

                disabled={
                  actionProcessing || Object.keys(formikData.errors).length > 0
                }

              >
                {actionProcessing ? "Sending..." : "Send"}
              </Button>
              <Dropzone
                onDrop={(acceptedFiles: File[]) => {
                  setUploadedFiles([]);
                  if (acceptedFiles.length > 0) {
                    const file = acceptedFiles[0];
                    setUploadedFiles([...acceptedFiles]);
                    formikData.setFieldValue("file", file);
                  }
                }}
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section className="file-drops">
                    <div
                      {...getRootProps({ className: "dropzone" })}
                      //   className="file-drop"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        // border: "1px solid #ccc",
                        padding: "5px 10px",
                        borderRadius: 4,
                        cursor: "pointer",
                        boxShadow:
                          "0 0px 4px 0 rgba(0,0,0,0.2), 0 0px 4px 0 rgba(0,0,0,0.19)",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Attach20Regular /> <p>Attach</p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default ComposeMessage;
